import api from '@/libs/axiosInstance';
import type { ApiResponse, NotificationPreferencesResponse } from '@fluenceur/types';
import { useQuery } from '@tanstack/react-query';

export const notificationPreferenceQueryKeys = {
  all: ['notification-preferences'] as const,
  brand: (brandId: string | null | undefined) =>
    [...notificationPreferenceQueryKeys.all, { brandId: brandId ?? null }] as const,
};

async function fetchNotificationPreferences(): Promise<NotificationPreferencesResponse> {
  const response = await api.get<ApiResponse<NotificationPreferencesResponse>>(
    '/dashboard/users/me/notification-preferences'
  );

  if (!response.data.data) {
    throw new Error('Notification preferences response is empty');
  }

  return response.data.data;
}

export function useNotificationPreferencesQuery(brandId: string | null | undefined) {
  return useQuery<NotificationPreferencesResponse, Error>({
    queryKey: notificationPreferenceQueryKeys.brand(brandId),
    queryFn: fetchNotificationPreferences,
    enabled: Boolean(brandId),
    staleTime: 30_000,
  });
}
